/* eslint react/jsx-key: off */
import React from 'react';
import PropTypes from 'prop-types';
import { Show, SimpleShowLayout, TextField, DateField, ReferenceField } from 'react-admin'; // eslint-disable-line import/no-unresolved


const PackageStockOutShow = ({ permissions, ...props }) => (
    <Show {...props}>
        <SimpleShowLayout>
            <ReferenceField label="resources.packagestockouts.fields.purchase" source="purchaseId" reference="purchases">
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="resources.packagestockouts.fields.package" source="packageId" reference="packages">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="qty" />
            <TextField source="warehouse" />
            <DateField source="stockInDate" options={{timeZone: "UTC"}}/>
            <ReferenceField label="resources.packagestockouts.fields.user" source="appUserId" reference="appusers">
                <TextField source="username" />
            </ReferenceField>

        </SimpleShowLayout>
    </Show>
);

PackageStockOutShow.propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    permissions: PropTypes.string,
};

export default PackageStockOutShow;
